//Generated File 
export default class DTOSecurityFieldAuthority{
	static readonly Disabled = `Disabled`;
	static readonly InVisible = `InVisible`;
	static readonly Normal = `Normal`;
	static readonly NotDefined = `NotDefined`;
}
